import React from "react";

import { useSelector } from "react-redux";
import { setScheduledTask } from "../../../store/api/tasks/reducer";
import { tasksSelector } from "../../../store/api/tasks/selector";
import { setErrorMsg } from "../../../store/helpers/helperReducers";
import { errorMsgSelector } from "../../../store/helpers/helperSelectors";
import { useStoreDispatch } from "../../../store/hooks";
import { isValidFile } from "../../../utils/validations";
import { Checkbox } from "../../ui/checkbox";
import { Label } from "../../ui/label";
import { InputField } from "../../Shared/Radix/Inputs/InputField";

export const SNDbBackup = () => {
    const dispatch = useStoreDispatch();
    const errorMsg = useSelector(errorMsgSelector);
    const scheduledtasks = useSelector(tasksSelector);

    const onInputChange = (name: string, value: string) => {
        dispatch(setScheduledTask({ [name]: value }));
        dispatch(setErrorMsg({ ...errorMsg, [name]: "" }));
    };

    const onBlurHandler = (event: React.FocusEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        if (!!value) {
            if (!isValidFile(value)) {
                dispatch(setErrorMsg({ ...errorMsg, [name]: "File Name/Prefix File Name should contain only alphanumeric characters or an underscore." }));
            }
        }
    };

    const checkboxHandler = (name: string, checked: boolean) => {
        if (name === "generateFileName") {
            if (checked) {
                dispatch(setScheduledTask({ [name]: checked, fileName: "", prefixFileName: "" }));
                dispatch(setErrorMsg({ ...errorMsg, fileName: "", prefixFileName: "" }));
            } else {
                dispatch(setScheduledTask({ [name]: checked }));
            }
        } else {
            dispatch(setScheduledTask({ [name]: checked }));
        }
    };

    return (
        <div className="flex flex-col gap-6">
            <p className="text-sm font-medium">
                {"Enter filename or prefix filename or check the 'Generate Filename' check box"}
            </p>
            <div className="flex items-center gap-2">
                <Checkbox
                    id="generateFileName"
                    checked={scheduledtasks?.generateFileName}
                    onCheckedChange={(checked) => checkboxHandler("generateFileName", !!checked)}
                />
                <Label htmlFor="generateFileName" className="cursor-pointer">Generate Filename</Label>
            </div>
            <InputField
                label="File Name"
                name="fileName"
                value={scheduledtasks?.fileName || ""}
                disabled={scheduledtasks?.generateFileName || scheduledtasks?.prefixFileName?.length >= 1}
                onChange={onInputChange}
                onBlur={onBlurHandler}
                placeholder="Enter file name"
            />
            <InputField
                label="Prefix File Name"
                name="prefixFileName"
                value={scheduledtasks?.prefixFileName || ""}
                disabled={scheduledtasks?.generateFileName || scheduledtasks?.fileName?.length >= 1}
                onChange={onInputChange}
                onBlur={onBlurHandler}
                 placeholder="Enter prefix file name"
            />
            <div className="flex items-center gap-2">
                <Checkbox
                    id="includeDbLogging"
                    checked={scheduledtasks?.includeDbLogging}
                    onCheckedChange={(checked) => checkboxHandler("includeDbLogging", !!checked)}
                />
                <Label htmlFor="includeDbLogging" className="cursor-pointer">Include Database Logging</Label>
            </div>
        </div>
    );
};